import React, { Component } from 'react'
import { ContentHeader, FlowTable, StaticBox } from 'components/basic'
import Pagination from 'react-js-pagination'
import Select from 'react-select'
import http from 'API/http'
import { HttpFilter } from 'projects/access-gui/components'

class AccessOverview extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activePage: 1,
      count: 20,
      totalResults: 0,
      accesses: [],
      loading: true,
      order: 'DESC'
    }
  }
  async getAccesses () {
    this.setState({loading: true})
    var [err, res] = await http.get('2.4/accesses/', {
      limit: this.state.count,
      offset: (this.state.activePage - 1) * this.state.count,
      filters: this.state.filters,
      sortBy: this.state.sortBy,
      order: this.state.order

    })
    if (err) return this.setState({error: true, loading: false})
    this.setState({accesses: res.data, totalResults: res.headers['x-total-count'], loading: false})
  }
  filter (filters) {
    clearTimeout(this.timer)
    this.setState({filters: filters, activePage: 1})
    this.timer = setTimeout(() => {
      this.getAccesses()
    }, 350)
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Accesses' subtitle='Overview' icon='fa-home' />
        <hr />
        <div className='row'>
          <HttpFilter endpoint='2.4/deepstream/record/' callback={filters => this.filter(filters)} filters={[
            {type: 'search', pattern: /^[0-9]*$/, operator: 'CONTAINS', key: 'accessId', name: 'Access ID'},
            {type: 'search', pattern: /^[0-9]*$/, operator: 'CONTAINS', key: 'apartmentNo', name: 'Apartment Number'},
            {type: 'search', pattern: /^[A-Öa-ö0-9 ]*$/, operator: 'CONTAINS', key: 'Address:attributes->>Apartment address', name: 'Apartment address'},
            {type: 'search', pattern: /^[A-Öa-ö ]*$/, operator: 'CONTAINS', key: 'city', name: 'City'},
            {type: 'search', pattern: /^[A-Öa-ö ]*$/, operator: 'CONTAINS', key: 'streetName', name: 'Street Name'},
            {type: 'search', pattern: /^[0-9]*$/, operator: 'EQUAL', key: 'streetNumber', name: 'Street Number'},
            {type: 'search', pattern: /^[A-Öa-ö ]*$/, operator: 'CONTAINS', key: 'streetLitteral', name: 'Street Litteral'},
            {type: 'search', pattern: /^[0-9]*$/, operator: 'EQUAL', key: 'postalCode', name: 'Postal Code'},
          ]}
           />
          <StaticBox badges={[{ value: this.state.totalResults }]} title='Accesses' icon='home'>
            <FlowTable error={this.state.error} hideHeaders emptyIcon='fa-search' emptyText='No results' loading={this.state.loading} data={this.state.accesses.map(access => [
              { onClick: () => (window.location = '#/access/' + access.accessId) },
              <a className='table-link' href={'#/access/' + access.accessId}><i className='fa fa-folder-open-o' /></a>,
              access.accessId,
              access.streetName,
              access.streetNumber,
              access.streetLittera,
              access.mduApartmentNumber,
              access.city,
              access.postalCode
            ])}>
              <tr>
                <th className='buttons' />
                <th onClick={e => this.setState({sortBy: 'accessId', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'accessId' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Access ID</th>
                <th onClick={e => this.setState({sortBy: 'streetName', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'streetName' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Street Name</th>
                <th onClick={e => this.setState({sortBy: 'streetNumber', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'streetNumber' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Street Number</th>
                <th onClick={e => this.setState({sortBy: 'streetLitteral', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'streetLittera' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Street Litteral</th>
                <th onClick={e => this.setState({sortBy: 'apartmentNo', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'apartmentNo' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Apartment Number</th>
                <th onClick={e => this.setState({sortBy: 'city', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'city' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} City</th>
                <th onClick={e => this.setState({sortBy: 'postalCode', order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')}, this.getAccesses)} className='clickable'>{this.state.sortBy === 'postalCode' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Postal Code</th>
              </tr>
            </FlowTable>
            <div className='row' hidden={this.state.error}>
              <div className='col-md-6'>
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.count}
                  totalItemsCount={parseInt(this.state.totalResults)}
                  pageRangeDisplayed={5}
                  onChange={e => this.setState({activePage: e}, this.getAccesses)}
                />
              </div>
              <div className='col-md-6'>
                <Select
                  className='table-pagination-select pull-right'
                  searchable={false}
                  labelKey='value'
                  valueKey='value'
                  clearable={false}
                  value={this.state.count}
                  options={[{ value: 5 }, { value: 10 }, { value: 20 }, { value: 30 }, { value: 50 }, { value: 100 }]}
                  onChange={(num) => this.setState({ count: num.value }, this.getAccesses)}
                />
              </div>
            </div>
          </StaticBox>
        </div>
      </div>
    )
  }
}

export default AccessOverview



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/access/overview.js